module.exports = __webpack_public_path__ + "ce26ffab81500d070b98a2e73db2fb23.svg";